import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=1a223b8a&scoped=true"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=1a223b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a223b8a",
  null
  
)

export default component.exports